import { PopupSuccess } from "@components/generals/popup";
import { Spiner } from "@components/loaders/spiner";
import {
  SettingUpdateAccount,
  settingUpdateAccountSchema,
} from "@components/resolvers/setting.resolvers";
import { yupResolver } from "@hookform/resolvers/yup";
import { AccountService } from "@services/account.service";
import { useNotificationStore } from "@stores/notification.store";
import { useThemeStore } from "@stores/theme.store";
import { useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { FaAt, FaCheck, FaPhone, FaTimes, FaUser } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";

export const SettingUpdateAccountPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [popup, setPopup] = useState<boolean>(false);
  const { setAppBar, setHeader } = useThemeStore((state) => state);
  const { pushNotification } = useNotificationStore((state) => state);
  const { register, handleSubmit, reset } = useForm<SettingUpdateAccount>({
    resolver: yupResolver<SettingUpdateAccount>(settingUpdateAccountSchema),
  });
  useEffect(() => {
    setAppBar({ title: "Ubah Data Akun" });
    setHeader({
      type: "small",
      title: "Ubah Data Akun",
      avatar: false,
      buttonBack: true,
    });
    initValidate();
    reset({
      username: state.username ?? "",
      nohp: state.nohp ?? "",
      email: state.email ?? "",
    });
  }, [setAppBar, setHeader, reset, state]);

  const { mutate, isLoading } = useMutation(AccountService.updateAccount, {
    onSuccess: (response) => {
      if (response.success) {
        setPopup(true);
      } else {
        pushNotification({
          type: "error",
          message: response.message,
        });
      }
    },
    onError: (error: any) => {
      pushNotification({
        type: "error",
        message: error.message ?? "Internal Error",
      });
    },
  });

  return (
    <>
      <div className="card card-style">
        <div className="content mb-0">
          <p className="mb-3">
            Sebelum merubah data, mohon untuk memastikan data akun sesuai dengan
            data yang ada dan mudah untuk di ingat.
          </p>

          <form
            autoComplete="off"
            method="post"
            onSubmit={handleSubmit((data) => mutate(data))}
          >
            <div className="input-style has-borders has-icon validate-field mb-4">
              <i className="lh-1">
                <FaUser />
              </i>
              <input
                type="text"
                className="form-control"
                placeholder="Username"
                {...register("username")}
              />
              <label className="color-blue-dark font-10 mt-1">Username</label>
              <i className="disabled invalid color-red-dark">
                <FaTimes />
              </i>
              <i className="disabled valid color-green-dark">
                <FaCheck />
              </i>
              <em>(*wajib)</em>
            </div>

            <div className="input-style has-borders has-icon validate-field mb-4">
              <i className="lh-1">
                <FaAt />
              </i>
              <input
                type="email"
                className="form-control"
                placeholder="Alamat Email"
                {...register("email")}
              />
              <label className="color-blue-dark font-10 mt-1">
                Alamat Email
              </label>
              <i className="disabled invalid color-red-dark">
                <FaTimes />
              </i>
              <i className="disabled valid color-green-dark">
                <FaCheck />
              </i>
              <em>(*wajib)</em>
            </div>

            <div className="input-style has-borders has-icon validate-field mb-4">
              <i className="lh-1">
                <FaPhone />
              </i>
              <input
                type="number"
                className="form-control"
                placeholder="Nomor Handphone"
                {...register("nohp")}
              />
              <label className="color-blue-dark font-10 mt-1">
                Nomor Handphone
              </label>
              <i className="disabled invalid color-red-dark">
                <FaTimes />
              </i>
              <i className="disabled valid color-green-dark">
                <FaCheck />
              </i>
              <em>(*wajib)</em>
            </div>

            <button
              type="submit"
              className="btn btn-m mt-4 mb-3 btn-full tw-w-full bg-blue-dark rounded-sm text-uppercase font-900"
            >
              {isLoading ? <Spiner /> : "SIMPAN PERUBAHAN"}
            </button>
          </form>
        </div>
      </div>
      <PopupSuccess
        show={popup}
        title="Berhasil!"
        message="Password berhasil di reset ulang, pastikan untuk menyimpan password"
        textButton="Kembali"
        onConfirm={() => navigate(-1)}
      />
    </>
  );
};
